import * as React from 'react';

import moment from 'moment-timezone';

import { StarRating } from 'components/StarRating/StarRating';

import { useAppContext } from 'hooks/context/useAppContext';
import { useReview } from 'hooks/review/useReview';

import { TReview } from 'types/review';

import s from './Reviews.module.css';

type TProps = {
  review: TReview;
};

export const Review = ({ review }: TProps) => {
  const {
    publicUser: { multi_user: isMultiUser },
  } = useAppContext();
  const reviewData = useReview({ review });
  const {
    rating,
    user_name,
    created_at,
    reviewer_name,
    isFullMessageDisplayed,
    showFullMessage,
  } = reviewData;

  return (
    <article className={s.review}>
      <header className={s.header}>
        <StarRating
          value={rating}
          fillColor="var(--accent-gradient-primary)"
          fillStrokeColor="var(--accent-gradient-primary)"
          emptyColor="transparent"
          emptyStrokeColor="var(--accent-gradient-primary)"
        />
        <h3 className={s.servicesName}>
          {isMultiUser ? `with ${user_name}` : null}
        </h3>
      </header>
      {reviewData.message.length > 0 && (
        <>
          <blockquote className={s.message}>{reviewData.message}</blockquote>
          {!isFullMessageDisplayed && (
            <button
              type="button"
              className={s.moreButton}
              onClick={showFullMessage}
            >
              Show More
            </button>
          )}
        </>
      )}
      <footer className={s.footer}>
        {moment(created_at).format('MM.DD.YYYY')} &#183; {reviewer_name}
      </footer>
    </article>
  );
};
